import { MMButton } from '@components'
import { useOnboardingAction } from '@hooks'
import cn from '@integrations/classnames'
import { useContext } from '@integrations/react'
import { GlobalContext, tr } from 'mmfintech-commons'

import styles from './StartVerificationModal.module.scss'

// Shown instead of the real IbanRequestFlow wizard when a prospect (unverified merchant) clicks
// the dashboard banner's "Issue IBAN" CTA — IBAN issuing isn't available to prospects, so this
// prompts them to complete verification instead of opening a flow they can't actually use.
function StartVerificationModal() {
  const { modalHide } = useContext(GlobalContext)
  const { startOrContinueOnboarding } = useOnboardingAction()

  function handleStartVerification() {
    modalHide()
    startOrContinueOnboarding()
  }

  return (
    <div className={cn(styles['start-verification-modal'])} data-test='start-verification-modal'>
      <div className={cn(styles['start-verification-title'])}>
        {tr('FRONTEND.DASHBOARD.ISSUE_IBAN_BANNER.VERIFY_TITLE', 'Verify your account to issue an IBAN')}
      </div>
      <div className={cn(styles['start-verification-body'])}>
        {tr(
          'FRONTEND.DASHBOARD.ISSUE_IBAN_BANNER.VERIFY_BODY',
          'IBAN issuing is only available to verified accounts. Complete your account verification to get access to this and other features.'
        )}
      </div>
      <MMButton
        type='button'
        variant='primary'
        caption={tr('FRONTEND.DASHBOARD.ISSUE_IBAN_BANNER.VERIFY_BUTTON', 'Start verification')}
        onClick={handleStartVerification}
        fullWidth
        data-test='button-start-verification'
      />
    </div>
  )
}

export default StartVerificationModal
